import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.js"

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import {createApp, markRaw} from 'vue'
import { createPinia } from "pinia";
import { createAuth0 } from "@auth0/auth0-vue";
import authConfig from "../auth_config.json";

import App from './App.vue'
import {createRouter} from './router'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app
    .use(pinia)
    // Router vóór Auth0: de Auth0-plugin pakt bij installatie app.config.globalProperties.$router
    // om na een login terug te sturen naar de oorspronkelijke pagina (appState.target). Stond de
    // router er nog niet, dan kwam je na elke login op / en dus op het overzicht terecht.
    .use(createRouter(app))
    .use(
        createAuth0({
            domain: authConfig.domain,
            clientId: authConfig.clientId,
            // Sessie in localStorage bewaren: een volledige herlaad van een diepe URL (bijv. een
            // vragenlijst) hoeft dan niet via een iframe opnieuw in te loggen. Dat iframe mislukt
            // wanneer third-party cookies geblokkeerd zijn (incognito), met een nieuwe login als gevolg.
            cacheLocation: 'localstorage',
            authorizationParams: {
                redirect_uri: window.location.origin,
            }
        })
    )
    .mount('#app')

// createApp(App).use(router).mount('#app')

